import { SpyneTrait } from "spyne";
import { compose, defaultTo, filter, head, pick, prop, whereEq } from "ramda";
import { snakeCase } from "change-case";
import { UtilTraits } from "traits/util-traits";

export class SidebarTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "sidebar$";

    super(context, traitPrefix);
  }

  static sidebar$getState(routePayload, srcElement) {
    const { routeData, pathsChanged, pathInnermost } =
      routePayload ?? routePayload.routePayload;
    const { pageId, container } = routeData;
    let { typeId, exampleId, itemId, isDeepLink } = routeData;
    //typeId = typeId || 'viewstream';
    exampleId = exampleId || "instance";
    const revealSidebar = this.sidebar$getRevealSidebarValByPageId(pageId);
    const revealSidebarHasChanged =
      this.sidebar$checkForRevealSidebarHasChanged(pageId);

    const pageChanged =
      pathInnermost === "pageId" && pathsChanged.includes("pageId");
    const typeChanged = pathInnermost === "typeId" && pageChanged === false;
    const exampleChanged =
      pathInnermost === "exampleId" &&
      pageId === false &&
      typeChanged === false;
    /*    console.log("SIDEBAR STATE ", {
      pageChanged,
      typeChanged,
      exampleChanged,
      revealSidebar,
      exampleId,
    });*/

    if (revealSidebar === false && revealSidebarHasChanged === false) {
      //console.log("NOTHING TO DO ");
      return;
    }

    // let action = "CHANNEL_SIDEBAR_NAVIGATION_EVENT";

    let action =
      revealSidebarHasChanged === false
        ? "CHANNEL_SIDEBAR_NAVIGATION_EVENT"
        : revealSidebar === true
          ? "CHANNEL_SIDEBAR_REVEAL_PANEL"
          : "CHANNEL_SIDEBAR_HIDE_PANEL";

    const menuData = this.props.data.quickStartData;
    const menuType = "quickStart";
    const { data } = this.props;

    if (itemId === undefined) {
      if (pageId === "docs") {
        const appendVal =
          routeData?.stage !== "" ? routeData?.stage : routeData?.section;
        itemId = `docs-${appendVal}`;
      }
    }
    // const itemId = this.sidebar$CreateGetItemIdPredFromAllData({routeData, pathsChanged, pathInnermost}, data);
    const payload = {
      revealSidebar,
      itemId,
      revealSidebarHasChanged,
      data,
      pageChanged,
      typeChanged,
      container,
      exampleChanged,
      pageId,
      typeId,
      exampleId,
      isDeepLink: routePayload?.isDeepLink,
      pathInnermost,
      pathsChanged,
      routeData,
      menuData,
      menuType,
    };

    //console.log("STATE VALUES ", { action, routePayload, payload, data });

    this.sendChannelPayload(action, payload, srcElement);
  }

  static sidebar$CreateGetItemIdPredFromAllData(payload = {}, allData = {}) {
    const pageId = payload?.pageId || payload?.routeData?.pageId;

    const dataHash = {
      docs: allData.docsContent,
      home: allData.homePageContent,
      tools: allData.toolsPageContent,
      compare: allData.comparePageContent,
      reference: allData.referencePageContent,
      configure: allData.configuratorPageContent,
    };

    const data = dataHash[pageId] || {};

    return SidebarTraits.sidebar$CreateGetItemIdPredFromRouteData(
      payload,
      data,
    );
  }

  static sidebar$CreateGetItemIdPredFromRouteData(
    payload = {},
    data = { menuData: [] },
  ) {
    const { pathInnermost, pathsChanged, routeData } = payload;
    //console.log("PAGE ID ",{pathInnermost, pathsChanged, routeData, payload, data})

    const searchVals = pick(pathsChanged, routeData);
    searchVals["itemType"] = pathInnermost;

    const pred = compose(whereEq(searchVals), prop("menuData"));

    const id = compose(
      defaultTo(false),
      prop("itemId"),
      head,
      filter(pred),
    )(data);

    return id;
  }

  static sidebar$GetItemIdByRouteData(routeData) {
    const { pageId, stage, section, classMethod, container } = routeData;

    //    const sel = `[data-page-id='${pageId}'][data-stage-id='${stage}'][data-container-id='${container}']`;
    const getRefPageId = () =>
      UtilTraits.utils$SanitizeForUrl(`${pageId}-${stage}`);
    //const getDocPageId = () => UtilTraits.utils$SanitizeForUrl(`${pageId}-${section}`);
    const getDocPageId = () => container ? `[data-page-id='${pageId}'][data-stage='${stage}'][data-container='${container}']` : `[data-page-id='${pageId}'][data-stage='${stage}'][data-container='']` ;

    return pageId === "reference" ? getRefPageId() : getDocPageId();
  }

  static sidebar$checkForRevealSidebarHasChanged(revealSidebar) {
    //console.log("REFVEAL SIDEBAR",revealSidebar);

    const checkDiffMethodGenerator = (defaultVal = false) => {
      let currentVal = defaultVal;
      return (newVal) => {
        const valChangedBool = newVal !== currentVal;
        currentVal = newVal;
        return valChangedBool;
      };
    };

    if (this.props.sideBarRevealSidebarValChangeCheck === undefined) {
      this.props.sideBarRevealSidebarValChangeCheck =
        checkDiffMethodGenerator(false);
    }

    return this.props.sideBarRevealSidebarValChangeCheck(revealSidebar);
  }

  static sidebar$getRevealSidebarValByPageId(pageId) {
    const showPageIdsArr = ["docs", "tools", "compare", "reference"];
    return showPageIdsArr.includes(pageId);
  }

  static sidebar$GetChannelAction(revealSidebar = true) {
    return revealSidebar
      ? "CHANNEL_SIDEBAR_REVEAL_PANEL"
      : "CHANNEL_SIDEBAR_HIDE_PANEL";
  }

  static sidebar$GetChannelPayload(revealSidebar, pageId) {
    if (revealSidebar === false) {
      return {};
    }

    const dataHash = {
      "getting-started": this.props.data.quickStartData,
    };

    return dataHash[pageId];
  }

  static sidebar$ConformSidebarData(data) {
    const dashCase = (s) => snakeCase(s, { delimiter: "-" });

    const { types } = data.codeGenData;

    const reduceMenuType = (acc, typeObj, n) => {
      const pageId = "getting-started";

      //let typeId = dashCase(typeObj.type);
      let typeId = String(typeObj.type).toLowerCase();

      const createSubMenuItem = (o, level = 2) => {
        const text = o.info.title;
        const exampleId = o.name; // dashCase(text)
        return { text, exampleId, pageId, typeId, level };
      };

      const createMenuItem = (text, level = 1) => {
        return { pageId, text, typeId, level };
      };

      const reduceSubMenuType = (a, o) => {
        a.push(createSubMenuItem(o));
        return a;
      };

      acc.push(createMenuItem(typeObj.type));
      typeObj.states.reduce(reduceSubMenuType, acc);

      return acc;
    };

    const quickStartData = types.reduce(reduceMenuType, []);

    data.quickStartData = quickStartData;

    //console.log('code gen data is ',{quickStartData,types})

    return data;
  }

  static sidebar$HelloWorld() {
    return "Hello World";
  }
}
